import React from 'react'
import styled from 'styled-components'

export interface ModalProps {
  onDismiss?: () => void
}

const Modal: React.FC<{maxWidth?: number, padding?: string, backgroundColor?: string}> = ({ maxWidth, padding, backgroundColor, children }) => {
  return (
    <StyledResponsiveWrapper maxWidth={maxWidth} padding={padding} backgroundColor={backgroundColor}>
      <StyledModal>{children}</StyledModal>
    </StyledResponsiveWrapper>
  )
}

const StyledResponsiveWrapper = styled.div<{maxWidth?: number, padding?: string, backgroundColor?: string}>`
  display: flex;
  margin: auto;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  background: ${({backgroundColor}) => backgroundColor ? backgroundColor : ({theme}) => theme.bg1 };
  border-radius: 20px;
  width: 100%;
  max-width: ${({maxWidth}) => maxWidth ? maxWidth : 512}px;
  padding: ${({padding}) => padding ? padding : '24px 32px 40px'};
`

const StyledModal = styled.div`
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-height: 0;
`

export default Modal
